// @ts-ignore
import Index from './src/Index.vue'
import {withInstall} from "../../utils/install";

Index.name = 'icon-select';
export const IconSelect = withInstall(Index);

export default IconSelect;
